var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064855"
    },
    d: "M455.682,274.5C458.505,260.101,460,245.226,460,230C460,102.975,357.026,0,230,0S0,102.975,0,230 c0,110.163,77.456,202.22,180.875,224.724L455.682,274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03242B"
    },
    d: "M47.313,321.163l133.561,133.561C196.705,458.169,213.138,460,230,460 c111.799,0,204.953-79.773,225.682-185.5l-19.591-19.591L47.313,321.163z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4F5FF"
    },
    points: "47.682,175 40.182,255 186.182,265 196.182,165  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.182,255l-3.798,30.386C32.973,312.674,52.682,335,80.182,335h106v-80H40.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DE1FF"
    },
    d: "M76.182,235c0,0,0,9,0,20s9,20,20,20h90v-40H76.182z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4DE1FF"
    },
    points: "76.182,195 76.182,215 186.182,215 196.182,205 186.182,195 131.182,185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#89EBFF"
    },
    points: "146.182,95 76.182,95 76.182,135 166.182,135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4DE1FF"
    },
    points: "281.182,125 228.682,125 228.682,155 296.182,155  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4F5FF"
    },
    points: "76.182,165 186.182,155 186.182,135 76.182,135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4F5FF"
    },
    points: "176.182,225 176.182,275 186.182,275 196.182,225  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.182,
    y: 225,
    style: {
      fill: "#C4F5FF"
    },
    width: 20,
    height: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#89EBFF"
    },
    points: "316.182,155 186.182,155 186.182,265 356.182,255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4F5FF"
    },
    points: "436,255 186.182,255 186.182,335 370.182,335  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2DB8D4"
    },
    d: "M186.182,235v40h90c11,0,20-9,20-20s0-20,0-20H186.182z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2DB8D4"
    },
    points: "76.182,175 76.182,195 186.182,195 196.182,185 186.182,175 131.182,165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2DB8D4"
    },
    points: "186.182,195 186.182,215 296.182,215 296.182,195 241.182,185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C8FAA"
    },
    points: "186.182,175 186.182,195 296.182,195 296.182,175 241.182,165  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.182,
    y: 225,
    style: {
      fill: "#89EBFF"
    },
    width: 10,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.182,
    y: 225,
    style: {
      fill: "#89EBFF"
    },
    width: 20,
    height: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "50.182,155 47.683,175 186.182,175 196.182,165 186.182,155  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.182,
    y: 155,
    style: {
      fill: "#C4F5FF"
    },
    width: 150,
    height: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipIcon);
export default __webpack_public_path__ + "static/media/ship_icon.2a8c91961e3165cd014c13a3de879b5f.svg";
export { ForwardRef as ReactComponent };